<template>
  <div>
    <div class="page_style lanmupage page_l61">
      <div class="top_box">
        <div class="top_box_inner">
          <div class="topcontent">
            <div class="Most-top">
              <div style="float: left">
                <!-- Add any content here if necessary -->
              </div>
              <div style="float: right">
                <a @click="setHome" href="#" class="top-swsy">设为首页</a> |
                <a @click="addToFavorites" href="#" class="top-jrsc"
                  >加入收藏</a
                >
              </div>
            </div>
          </div>
          <div class="clear"></div>
          <div class="logo">
            <a href="/" style="display: block"
              ><img src="../assets/picture/logo.png" alt="Logo" border="0"
            /></a>
          </div>
          <div class="menu_box" id="Menu">
            <ul>
              <li
                v-for="(menuItem, index) in menuItems"
                :key="index"
                :class="['menu_style', { menu_current: menuItem.active }]"
              >
                <a :href="menuItem.link" class="menu">{{ menuItem.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="aboutContent">
        <!-- <p>
           -   人力资源测评管理中心专项职业能力测评管理委员会（以下简称中心管委会）是根据《国家中长期人才发展规划》、国务院《国家职业教育改革实施方案》，为了贯彻落实《国务院关于加强职业培训促进就业的意见》、《国务院关于推行终身职业技能培训制度的意见》及人力资源和社会保障部《关于开展单项职业能力考核试点工作的通知》，积极响应中共中央办公厅、国务院办公厅《关于分类推进人才评价机制改革的指导意见》及人力资源和社会保障部〔2017〕68号文件中提出的行业协会、学会等社会组织和企事业单位依据市场需求自行开展能力水平评价工作等政策的指导下经政府行政审批有关部门批准设立的专业第三方人力资源测评机构。
           - </p>
           - <p>
           -   中心管委会依托国家建立的技能人才多元评价机制，以职业能力为导向、以工作业绩为重点、注重工匠精神培育和职业道德养成的技能人才评价体系，结合职业标准和岗位要求、职业能力考核和工作业绩评价、专业评价和企业认可相结合的原则，对技术技能型人才突出实际操作能力和解决关键生产技术难题要求，对知识技能型人才突出掌握运用理论知识指导生产实践、创造性开展工作要求，对复合技能型人才突出掌握多项技能、从事多工种多岗位复杂工作要求，进行专业、客观、公正、独立的测评与系统评价。测评合格后颁发对应等级的专项职业能力水平等级证书，可作为用人单位能力评价、考核、聘用、继续教育学时的参考依据。不能代替行业主管部门所要求的持证上岗等各种法律及政策的要求，依法准入类职业及特种作业仍需要按照法律及相关部门的政策依法持证上岗。
           - </p>
           - <p>
           -   中心管委会开展的专项职业能力评价活动，是根据市场需求基于测评双方自愿原则开展的人力资源水平测评，测评结果仅表明劳动者能熟练掌握并应用某项实用职业技能，表明劳动者具备了从事某职业岗位所必需的基本工作能力。
           - </p>
           - <p>
           -   中心管委会颁发的人力资源测评专项职业能力等级证书属于人力资源测评证明，不是特种作业证件，不属于从业准入类证书，不能替代政府应急(安监)、市监（质监）、住建等部门的特种作业操作证、特种设备作业人员证、建筑施工特种作业操作资格证等使用。
           - </p>
           - <p>
           -   本网站(www.osta.sx.cn)为人力资源测评管理中心专项职业能力测评管理委员会签发的人力资源测评证书唯一查询官网，谨防假冒。请各合作共建机构，认真阅读了解中心管委会官网“关于我们”，如有存在利用自媒体引流推广时违规宣传、误导炒作、夸大宣传的现象，请立即整改删除，以免误导公众。针对存在上述问题拒不整改的机构，造成违法违规的，各合作共建机构后果自负。
           - </p> -->
        <p>
          人力资源测评管理委员会专项职业能力测评中心（以下简称中心）是根据《国家中长期人才发展规划》、国务院《国家职业教育改革实施方案》，为了贯彻落实《国务院关于加强职业培训促进就业的意见》、《国务院关于推行终身职业技能培训制度的意见》及人力资源和社会保障部《关于开展单项职业能力考核试点工作的通知》，积极响应中共中央办公厅、国务院办公厅《关于分类推进人才评价机制改革的指导意见》及人力资源和社会保障部〔2017〕68号文件中提出的行业协会、学会等社会组织和企事业单位依据市场需求自行开展能力水平评价工作等政策的指导下经政府行政审批有关部门批准设立的专业第三方人力资源测评机构。
        </p>
        <p>
          中心依托国家建立的技能人才多元评价机制，以职业能力为导向、以工作业绩为重点、注重工匠精神培育和职业道德养成的技能人才评价体系，结合职业标准和岗位要求、职业能力考核和工作业绩评价、专业评价和企业认可相结合的原则，对技术技能型人才突出实际操作能力和解决关键生产技术难题要求，对知识技能型人才突出掌握运用理论知识指导生产实践、创造性开展工作要求，对复合技能型人才突出掌握多项技能、从事多工种多岗位复杂工作要求，进行专业、客观、公正、独立的测评与系统评价。测评合格后颁发对应等级的专项职业能力水平等级证书，可作为用人单位能力评价、考核、聘用、继续教育学时的参考依据。不能代替行业主管部门所要求的持证上岗等各种法律及政策的要求，依法准入类职业及特种作业仍需要按照法律及相关部门的政策依法持证上岗。
        </p>
        <p>
          中心开展的专项职业能力评价活动，是根据市场需求基于测评双方自愿原则开展的人力资源水平测评，测评结果仅表明劳动者能熟练掌握并应用某项实用职业技能，表明劳动者具备了从事某职业岗位所必需的基本工作能力。
        </p>
        <p>
          中心颁发的人力资源测评专项职业能力等级证书属于人力资源测评证明，不是特种作业证件，不属于从业准入类证书，不能替代政府应急(安监)、市监（质监）、住建等部门的特种作业操作证、特种设备作业人员证、建筑施工特种作业操作资格证等使用。
        </p>
        <p>
          本网站(www.osta.sx.cn)为人力资源测评管理委员会专项职业能力测评中心签发的人力资源测评证书唯一查询官网，谨防假冒。请各合作共建机构，认真阅读了解中心官网“关于我们”，如有存在利用自媒体引流推广时违规宣传、误导炒作、夸大宣传的现象，请立即整改删除，以免误导公众。针对存在上述问题拒不整改的机构，造成违法违规的，各合作共建机构后果自负。
        </p>
      </div>
      <div class="bottom_box">
        <div
          style="
            clear: both;
            overflow: hidden;
            background: #eee;
            height: 100%;
            padding-top: 15px;
            padding-bottom: 15px;
            margin: 0 auto;
          "
        >
          <table align="center">
            <tr>
              <td>
                <p>
                  <a href="/" target="_blank">关于我们</a>
                  <a class="footerItem" href="/" target="_blank">隐私声明</a>
                  <a class="footerItem" href="/" target="_blank">联系我们</a>
                  <a class="footerItem" href="/" target="_blank">版权声明</a>
                </p>
                <p>备案号：晋ICP备2021017782号-2</p>
                <!-- <p>人力资源测评管理中心专项职业能力测评管理委员会版权所有</p> -->
                <p>人力资源测评管理委员会·专项职业能力测评中心版权所有</p>
              </td>
              <!-- <td>
                    <img src="../assets/picture/sydw.png" width="80" height="100" />
                </td> -->
            </tr>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "",
  metaInfo(){
    return {
      title:"人力资源测评管理委员会·专项职业能力测评中心-关于我们",
      meta:[
        {
          charset: "utf-8"
        },
        {
          name: "keywords",
          content: "人力资源测评管理委员会·专项职业能力测评中心官网",
        },
        {
          name: "description",
          content: "人力资源测评管理委员会专项职业能力测评中心（以下简称中心）是根据《国家中长期人才发展规划》、国务院《国家职业教育改革实施方案》，为了贯彻落实《国务院关于加强职业培训促进就业的意见》、《国务院关于推行终身职业技能培训制度的意见》及人力资源和社会保障部《关于开展单项职业能力考核试点工作的通知》，积极响应中共中央办公厅、国务院办公厅《关于分类推进人才评价机制改革的指导意见》及人力资源和社会保障部〔2017〕68号文件中提出的行业协会、学会等社会组织和企事业单位依据市场需求自行开展能力水平评价工作等政策的指导下经政府行政审批有关部门批准设立的专业第三方人力资源测评机构。",
        }
      ]

    }
  },
  data() {
    return {
      menuItems: [
        { name: "首页", link: "/", active: true },
        { name: "新闻动态", link: "/", active: false },
        { name: "管理委员会", link: "/", active: false },
        { name: "课程中心", link: "/", active: false },
        { name: "在线测评", link: "/", active: false },
        { name: "党建工作", link: "/", active: false },
        {
          name: "证书查询",
          link: "http://www.sxcpzx.org.cn/select/wap/",
          active: false,
        },
      ],
    };
  },
};
</script>

<style scoped>
@import url(../assets/css/style.css);
@import url(../assets/css/submenu.css);
.bottom_box {
  padding-top: 0;
}
.aboutContent {
  width: 1100px;
  margin: 0 auto;
  background-color: #fff;
  padding: 30px 50px 30px 50px;
}
.aboutContent p {
  text-align: left;
  text-indent: 2em;
  line-height: 40px;
  font-size: 14px;
}
</style>